import { PendingDecision } from '@/components/editorial/PendingDecision';
import type { PendingDecisionId } from '@/lib/pending-decisions';

/**
 * A plain system note in a thread — a staff claim released, reassignment
 * narration, a receipt sent from chat (#2379): anything the surface writes
 * locally that carries its own copy and so cannot go through
 * HandoffSystemEvent's fixed sentences. Centred and muted, with no speaker
 * label and no actions, so it never reads as something the companion said.
 *
 * `decision` puts the `(?)` of an unruled choice about the note itself beside
 * it (the receipt note is local only: wave 2 `chat-receipt-thread-note`).
 */
export function SystemNote({ content, decision }: { content: string; decision?: PendingDecisionId }) {
  return (
    <div className="flex items-center justify-center gap-1.5" data-testid="system-note">
      <div className="rounded-md bg-muted px-3 py-1.5 text-caption italic text-stevens-ink-3 text-center max-w-[85%]">
        {content}
      </div>
      {decision && <PendingDecision id={decision} side="top" />}
    </div>
  );
}
